import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Measurement from "@arcgis/core/widgets/Measurement";
import Legend from "@arcgis/core/widgets/Legend";
import LayerList from "@arcgis/core/widgets/LayerList";
import { UserInformationService } from "../../shared/services/user/user-information.service";
import { DrawToolRemoveComponent } from "./draw/draw-remove-all/draw-remove-all";
import { DrawBufferToolbarComponent } from "./draw/draw-buffer/draw-buffer-toolbar";
import { DrawBufferCheckboxComponent } from "./draw/draw-buffer/draw-buffer-checkbox";
import { PrintComponent } from "./print/print.component";
import { ExtentComponent } from "./extent/extent.component";
import { LayerListComponent } from "./layer-list/layer-list.component";
import { BookmarkComponent } from "./bookmark/bookmark.component";
import { SearchComponent } from "./search/search.component";
import Bookmarks from "@arcgis/core/widgets/Bookmarks";
import CoordinateConversion from "@arcgis/core/widgets/CoordinateConversion";
import Sketch from "@arcgis/core/widgets/Sketch";
import { MeasureComponent } from "./measure/measure.component";
import Home from "@arcgis/core/widgets/Home";
import Expand from "@arcgis/core/widgets/Expand";
import Search from "@arcgis/core/widgets/Search";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { MapToolsServiceService } from "./map-tools-service.service";
import { AppControllerService } from "../../app-controller.service";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
import Fullscreen from "@arcgis/core/widgets/Fullscreen";
let MapTools = class MapTools {
    userInformationService;
    drawRemoveAll;
    bufferWindow;
    bufferCheckbox;
    measureTool;
    printTool;
    extentTool;
    layerList;
    bookmark;
    search;
    mapToolsService;
    appController;
    buffEnabled;
    bufferLayer;
    sketchGraphicsLayer;
    mapTools = [];
    expandableWidgets = {};
    savedBookmarks = false;
    userId = null;
    bookmarkSettingsId = null;
    bookmarksLoaded = false;
    bookmarkModuleId = null;
    authenticatedUserSubscription;
    getBookmarksSubscription;
    updateBookmarksSubscription;
    createBookmarksSubscription;
    createBookmarksUserSubscription;
    constructor(userInformationService, drawRemoveAll, bufferWindow, bufferCheckbox, measureTool, printTool, extentTool, layerList, bookmark, search, mapToolsService, appController) {
        this.userInformationService = userInformationService;
        this.drawRemoveAll = drawRemoveAll;
        this.bufferWindow = bufferWindow;
        this.bufferCheckbox = bufferCheckbox;
        this.measureTool = measureTool;
        this.printTool = printTool;
        this.extentTool = extentTool;
        this.layerList = layerList;
        this.bookmark = bookmark;
        this.search = search;
        this.mapToolsService = mapToolsService;
        this.appController = appController;
    }
    addBaseMaps(mapView) {
        const basemapGallery = new BasemapGallery({
            view: mapView, source: {
                portal: {
                    url: "https://www.arcgis.com", useVectorBasemaps: false
                }
            }
        });
        this.addToolExpand(mapView, basemapGallery, "basemapGalleryWidget", "top-right", "Select Basemap");
    }
    addDraw(mapView) {
        this.sketchGraphicsLayer = new GraphicsLayer({
            id: "Draw Tool Layer", title: "Draw Tool Layer", listMode: "hide",
        });
        this.bufferLayer = new GraphicsLayer({
            title: "Buffer Layer", listMode: "hide"
        });
        mapView.map.add(this.bufferLayer);
        mapView.map.add(this.sketchGraphicsLayer);
        // TODO: Hide error Accessor#set 'hybrid' is not a valid value for this property, only the following values are valid: 'freehand', 'click'
        const sketch = new Sketch({
            defaultCreateOptions: {
                mode: "hybrid"
            }, view: mapView, layer: this.sketchGraphicsLayer, id: "drawTool", container: document.createElement("div"),
        });
        this.drawRemoveAll.addRemoveAllButton(mapView, this.sketchGraphicsLayer, this.bufferLayer, sketch);
        this.bufferCheckbox.addBufferCheckbox(mapView);
        this.bufferWindow.addBufferWindow(mapView, sketch);
        this.addToolExpand(mapView, sketch, "drawTool", "top-left", "Draw", "brush-mark");
        sketch.on("create", event => {
            this.bufferWindow.addBuffer(event, this.bufferLayer, this.buffEnabled);
        });
        this.mapTools.push(sketch);
    }
    toggleBuffer(event) {
        this.buffEnabled = event;
        if (!event) {
            this.bufferLayer.removeAll();
        }
    }
    addMeasure(mapView) {
        const Measure = new Measurement({
            view: mapView, linearUnit: "meters", areaUnit: "square-meters", id: "measure"
        });
        const Location = new CoordinateConversion({
            view: mapView,
        });
        this.measureTool.initializeMeasureTool(mapView, Measure, Location);
        const btnMeasure = document.getElementById("measureWidget");
        this.addToolExpand(mapView, btnMeasure, "measureWidget", "top-left", "Measure", "measure-area");
    }
    addPrint(mapView, moduleId) {
        const print = this.printTool.initializePrintTool(mapView, moduleId);
        this.addToolExpand(mapView, print, "printWidget", "top-left", "Print");
    }
    addExtent(mapView, isSysAdmin) {
        if (isSysAdmin) {
            const textContainer = this.extentTool.addExtentTool(mapView);
            this.addToolExpand(mapView, textContainer, "textContainerWidget", "top-left", "Get Current Extent", "extent");
        }
    }
    addLegend(mapView) {
        const legend = new Legend({
            view: mapView
        });
        this.addToolExpand(mapView, legend, "legendWidget", "top-right", "Legend");
    }
    addLayerList(mapView) {
        const layerList = new LayerList({
            view: mapView, listItemCreatedFunction: this.layerList.layerActions
        });
        this.addToolExpand(mapView, layerList, "layerListWidget", "top-right", "Layers");
        layerList.on("trigger-action", event => {
            this.layerList.layerActionTrigger(event);
        });
    }
    addBookmark(mapView) {
        const bookmarks = new Bookmarks({
            view: mapView, editingEnabled: true,
        });
        let bookmarksCollection = null;
        this.authenticatedUserSubscription = this.userInformationService.$authenticatedUser.subscribe(user => {
            this.userId = +user.id;
            this.getBookmarksSubscription = this.mapToolsService.getBookmarks(this.userId, +this.appController.selectedModuleID).subscribe(settings => {
                if (settings.value.length > 0) {
                    this.bookmarkSettingsId = settings.value[0].id;
                    bookmarksCollection = JSON.parse(settings.value[0].value);
                    this.savedBookmarks = true;
                    bookmarks.bookmarks = bookmarksCollection;
                }
                else {
                    this.bookmarkSettingsId = null;
                    bookmarksCollection = this.bookmark.addBookmarks();
                    this.savedBookmarks = false;
                    bookmarks.bookmarks = bookmarksCollection;
                }
                this.bookmarkModuleId = +this.appController.selectedModuleID;
                this.bookmarksLoaded = true;
            });
        });
        this.addToolExpand(mapView, bookmarks, "bookmarksWidget", "top-right", "Bookmark");
        bookmarks.on("bookmark-edit", () => {
            if (this.bookmarksLoaded === true && this.bookmarkModuleId === +this.appController.selectedModuleID) {
                if (this.savedBookmarks === true) {
                    this.updateBookmarksSubscription = this.mapToolsService.updateBookmarks(this.bookmarkSettingsId, JSON.stringify(bookmarks.bookmarks)).subscribe(() => {
                        this.savedBookmarks = true;
                    });
                }
                else {
                    const setting = {
                        userId: this.userId,
                        moduleId: +this.appController.selectedModuleID,
                        key: "Bookmarks",
                        value: JSON.stringify(bookmarks.bookmarks),
                        deleted: false
                    };
                    this.createBookmarksSubscription = this.mapToolsService.createBookmarks(setting).subscribe(() => {
                        this.savedBookmarks = true;
                    });
                }
            }
        });
        const handle = reactiveUtils.watch(() => bookmarks.bookmarks.map(bookmark => bookmark), () => {
            if (this.bookmarksLoaded === true && this.bookmarkModuleId === +this.appController.selectedModuleID) {
                if (this.savedBookmarks === true) {
                    this.updateBookmarksSubscription = this.mapToolsService.updateBookmarks(this.bookmarkSettingsId, JSON.stringify(bookmarks.bookmarks)).subscribe(settings => {
                        this.savedBookmarks = true;
                    });
                }
                else {
                    const setting = {
                        userId: this.userId,
                        moduleId: +this.appController.selectedModuleID,
                        key: "Bookmarks",
                        value: JSON.stringify(bookmarks.bookmarks),
                        deleted: false
                    };
                    this.createBookmarksUserSubscription = this.mapToolsService.createBookmarks(setting).subscribe(user => {
                        this.savedBookmarks = true;
                    });
                }
            }
        });
    }
    addSearch(mapView) {
        const sources = this.search.getCustomSources();
        const search = new Search({
            id: "searchWidget",
            view: mapView,
            allPlaceholder: "Search for place or address",
            sources,
            suggestionsEnabled: true,
            maxSuggestions: 20,
            minSuggestCharacters: 0,
            includeDefaultSources: false,
        });
        search.on("search-complete", (event) => {
            if (event && event.results && event.results.length > 0) {
                this.search.searchMultipleResults(event, mapView);
            }
        });
        mapView.ui.add(search, "top-right");
    }
    addHome(mapView) {
        const homeBtn = new Home({
            view: mapView
        });
        // Add the home button to the top left corner of the view
        mapView.ui.add(homeBtn, "top-right");
    }
    addToolExpand(mapView, tool, name, position, Title, icon) {
        const expand = new Expand({
            expandTooltip: Title, view: mapView, content: tool, expandIcon: icon
        });
        mapView.ui.add(expand, position);
        this.expandableWidgets[name] = expand;
    }
    getMapTool(id) {
        return this.mapTools.find(t => t.id === id);
    }
    expandWidget(name) {
        this.expandableWidgets[name].expand();
    }
    addFullScreenWidget(mapView) {
        const fullscreen = new Fullscreen({
            view: mapView
        });
        mapView.ui.add(fullscreen, "bottom-left");
    }
    static ctorParameters = () => [
        { type: UserInformationService },
        { type: DrawToolRemoveComponent },
        { type: DrawBufferToolbarComponent },
        { type: DrawBufferCheckboxComponent },
        { type: MeasureComponent },
        { type: PrintComponent },
        { type: ExtentComponent },
        { type: LayerListComponent },
        { type: BookmarkComponent },
        { type: SearchComponent },
        { type: MapToolsServiceService },
        { type: AppControllerService }
    ];
};
MapTools = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsub()
], MapTools);
export { MapTools };
